import { isEmptyString, isNonEmptyString, isNotNull } from '../../util/check';
import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewEncapsulation,
	OnDestroy,
} from '@angular/core';
import { FnDateFormatter } from '../../util/date';
import { Subject } from 'rxjs/internal/Subject';
@Component({
	selector: 'fn-mat-date-picker',
	templateUrl: './fn-mat-date-picker.component.html',
	styleUrls: ['./fn-mat-date-picker.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnMatDatePickerComponent implements OnInit, OnDestroy {
	@Input() isShowIcon = true;
	/**
	 * Input member of fn date picker component
	 * used to set selected Date when selected Date is not given or undefined
	 */
	@Input() currentDate = new Date();
	/**
	 * Input member of fn date picker component
	 * FNDateConfig Object used to set the properties of DatePicker.
	 */
	@Input() globalConfig: FnMatDateConfig;
	/**
	 * Input member of fn date picker component
	 * used to disable datePicker when true .
	 */
	@Input() isDisable = false;

	/**
	 * Input member of fn date picker component
	 * variable used to show the display format of date.
	 */
	@Input() format = 'd/M/Y';
	/**
	 * Input member of fn date picker component
	 * used to set SelectedDate if not given then Current Date is set.
	 */
	@Input() selectedDate: Date;
	/**
	 * Input member of fn date picker component
	 * variable used to pass Classes to the date picker panel.
	 */
	@Input() customClass: string;
	/**
	 * Output member of fn date picker component
	 * used to emit Event on Date Selection From DatePicker model .
	 */
	@Output() callback = new EventEmitter();

	@Output() dateCB = new EventEmitter<{
		isValid: boolean;
		selectedDate: Date;
	}>();

	@Output() dateDisabled = new EventEmitter();
	@Input() placeHolder = 'Choose a date';
	/**
	 * member of fn date picker component.
	 * variable used to show the view that the calendar should start in.
	 * default value is month view(days of month).
	 */
	startView = 'month';

	uiDate = '';


	changeDate(event: Event) {
    const value  =  new Date(this.uiDate);
    this.selectedDate = isEmptyString(this.uiDate) || value.toString()  === "Invalid Date" || value.getFullYear() < 1  ? null  : value;
    this.setDate();
  }

	/**
	 * varible to subscribe and Unsubscribe datePickerAction
	 */
	private isdatePickerAction = false;
	/**
	 * Implementing On init Event Handler to set default data
	 */
	ngOnInit() {
		this.isdatePickerAction = this.globalConfig !== undefined;
		if (this.isdatePickerAction) {
			this.globalConfig.datePickerAction.subscribe(
				(config: FnMatDateConfig) => {
					this.setGlobalConfig(config);
				}
			);
		} else {
			// tslint:disable-next-line: no-use-before-declare
			this.globalConfig = new FnMatDateConfig();
		}
		this.setGlobalConfig(this.globalConfig);
	}
	/**
	 * create mthod to set global configuration of date picker
	 * set the value of globalConfig variable and change the view of date picker according to weekly,monthly.
	 */
	private setGlobalConfig(globalConfig: FnMatDateConfig) {
		this.globalConfig = this.initGlbConfig(globalConfig);
		this.setDateModel(this.selectedDate);
		this.customClass =
			this.customClass === undefined
				? this.globalConfig.isMonthView
					? 'fn-date-month-picker'
					: ''
				: this.customClass;
		this.startView = this.globalConfig.isMonthView ? 'year' : 'month';
	}

	/**
	 * Get formatted date method
	 * @returns the date as the Format of date is Given.
	 */
	getFormattedDate() {
		return isNotNull(this.selectedDate) ? new FnDateFormatter().format(
			this.getDateObj(),
			this.globalConfig.format
		) : "";
	}

	/**
	 * Get date return the selected Date as DateObject.
	 * @returns DateObject;
	 */
	getDateObj() {
		return isNotNull(this.selectedDate) &&
			isNonEmptyString(this.selectedDate.toString())
			? new Date(this.selectedDate)
			: null;
	}

	/**
	 * Sets date
	 * method invoke when date is Selected. callback event Emitter emit the selectedDate Object
	 */
	setDate(isValid = true) {
		if (isValid) {
			this.uiDate = this.getFormattedDate();
		}
		this.dateCB.emit({ isValid, selectedDate: this.getDateObj() });
		this.callback.emit(this.getDateObj());
	}

	/**
	 * Sets selectDate value
	 * @param date Date Object.
	 */
	setDateModel(date: Date) {
		this.selectedDate = date;
		this.uiDate = this.getFormattedDate();
	}

	/**
	 * Date picker filter of fn date picker component
	 * Function that can be used to filter out dates within the datepicker.
	 */
	datePickerFilter = (date: Date) => {
		if (date === null || this.globalConfig.maxDate !== null) {
			return false;
		}
		if (this.globalConfig.isAutoHandler && this.globalConfig.isFutureDisable) {
			return new Date(date.toString()) <= this.globalConfig.disabledDate;
		}
		let returnVal = true;
		this.dateDisabled.emit({
			date: new Date(date.toString()),
			callback: (val: boolean) => {
				returnVal = val;
			},
		});
		return returnVal;
	};

	/**
	 * Gets next date method return the new DateObject by increasing the no of days pass as @param.
	 * @param noOfNavDay of type number added in date value.
	 * @returns  new Date Object.
	 */
	getNextDate(noOfNavDay: number) {
		const date = this.getDateObj();
		return new Date(date.setDate(date.getDate() + noOfNavDay));
	}

	/**
	 * Gets prev date return the new DateObject by decreasing the no of days pass as @param.
	 * @param  noOfNavDay of type number subtracted in date value.
	 * @returns  new Date Object.
	 */
	getPrevDate(noOfNavDay: number) {
		const date = this.getDateObj();
		return new Date(date.setDate(date.getDate() - noOfNavDay));
	}

	/**
	 * Method return the next Month to selected Date.
	 * @returns  new Date Object.
	 */
	getNextMonth() {
		const date = this.getDateObj();
		return new Date(date.getFullYear(), date.getMonth() + 1, 1);
	}

	/**
	 *  Method return the Previous Month to selected Date.
	 * @returns date object
	 */
	getPrevMonth() {
		const date = this.getDateObj();
		return new Date(date.getFullYear(), date.getMonth() - 1, 1);
	}

	/**
	 * Months selected handler this method called when monthView is True.
	 * @param event date value
	 * @param datePicker DatePikcer Object for closing DatePicker Modal.
	 */
	_monthSelectedHandler(event: Date, datePicker: any) {
		if (this.globalConfig.isMonthView) {
			this.setDateModel(new Date(event));
			this.setDate();
			datePicker.close();
		}
	}

	/**
	 * Method set global config Object value and if some member
	 * value is not passed then it set them as default FnDateConfig object member value.
	 * @param configHash FnDateConfig object passed as input
	 * @returns FnDateConfig object.
	 */
	initGlbConfig(configHash: FnMatDateConfig) {
		const returnGlbHash: any = Object.assign(configHash, {});
		// tslint:disable-next-line: no-use-before-declare
		const defaultCnfHash: any = new FnMatDateConfig();
		Object.keys(defaultCnfHash).forEach((key) => {
			if (!returnGlbHash.hasOwnProperty(key)) {
				returnGlbHash[key] = defaultCnfHash[key];
			} else if (key === 'type') {
				if (returnGlbHash[key] === 'month') {
					returnGlbHash.isMonthView = true;
				} else {
					returnGlbHash.isMonthView = false;
				}
			}
		});
		return returnGlbHash;
	}
	/**
	 * created destroy method to unsubsribe the method.
	 */
	ngOnDestroy() {
		if (this.isdatePickerAction) {
			this.globalConfig.datePickerAction.unsubscribe();
		}
	}
}

/**
 * Class used to Configure DatePicker Properies.
 */
export class FnMatDateConfig {
	/**
	 * Mindate to show in DatePicker.
	 */
	minDate: Date = new Date('1-1-1990');
	/**
	 * Maxdate to show in DatePicker
	 */
	maxDate: Date = null;
	/**
	 * Navigation
	 */
	navigation = 'select';
	/**
	 * starting Day to show on datePicker
	 * Default value is 2 (Monday)
	 */
	startingDay = 2;

	/**
	 * No of Months to display on DatePicker Calender
	 */
	displayMonths = 1;
	/*
	 * handle next prev functionality
	 */
	isAutoHandler = false; // handle next prev functionality
	/**
	 * use this if you are using the autoHandler.
	 */
	isFutureDisable = false;
	/**
	 * No of days to add or subtract when click on next or Prev button and isAutoHandler is true.
	 */
	noOfNavDay = 7;
	/**
	 * disabledDate used to compare date to disable date and next button if isAutoHandler and isFutureDisabled is true.
	 */
	disabledDate: Date = new Date();

	/**
	 * if true then show month only.
	 */
	isMonthView = false;
	/**
	 * used to show month view on datePicker
	 */
	type: string = null;
	/**
	 * angular subect method used to update date picker view based on weekly,monthly selected option
	 */
	datePickerAction: Subject<FnMatDateConfig> = new Subject();
	/**
	 * used to update the format of date based on weekly,monthly selected option
	 */
	format = 'm/d/Y';
}
